import { LANDING_PAGE_URL } from '../const/APIUrl.js';
import { redirect } from 'react-router-dom';
import { fetchAPI } from '../api/GenericFetch.js';

export async function authLoader()
{
    const response = await fetchAPI({url:LANDING_PAGE_URL, includeBundleResponse:true});    
    if (response !== undefined && response.ok) {
        return;
    }
        
    return redirect('/SignIn');
}